import "@refinedev/antd/dist/reset.css";
import "./global.css";

function App() {
  return null;
}

export default App;
